

export const clientSide  = <T>(func: () => T, ssReturn?: T ): T => {
  if (typeof window !== 'undefined') {
    return func();
  } else {
    return ssReturn;
  }
};